import { useDispatch } from 'react-redux';
import { actions as rankActions } from './actions';
import { CreateRankDTO } from '../api-types';
import { useCallback } from 'react';

export const useRankService = () => {
    const dispatch = useDispatch();

    // Memoized actions
    const getRank = useCallback((id: string) => dispatch(rankActions.getRank(id)), [dispatch]);
    const getArea = useCallback((id: string) => dispatch(rankActions.getArea(id)), [dispatch]);
    const getDispatchGroups = useCallback(() => dispatch(rankActions.getDispatchGroup()), [dispatch]);
    const createRank = useCallback(
        (data: CreateRankDTO, callback?: () => void) => {
            dispatch(rankActions.createRank(data, callback));
        },
        [dispatch],
    );
    const updateRank = useCallback(
        (id: string, data: CreateRankDTO, callback?: () => void) => {
            dispatch(rankActions.updateRank(id, data, callback));
        },
        [dispatch],
    );
    const deleteRank = useCallback(
        (id: string, callback?: () => void) => {
            dispatch(rankActions.deleteRank(id, callback));
        },
        [dispatch],
    );

    return {
        getRank,
        getArea,
        getDispatchGroups,
        createRank,
        updateRank,
        deleteRank,
    };
};
